import React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import Chip from "material-ui/Chip";
import { withStyles } from "material-ui/styles";
import Button from "antd/lib/button";

const styles = theme => ({
  root: {},
  chip: {}
});

const Output = ({
  hashtags = [],
  onDelete = () => alert("onDelete is undefined")
}) => {
  const currentCount = hashtags.length;
  const isDisabled = !currentCount || currentCount > 30;
  const chips = hashtags.map((x, i) => {
    return (
      <div key={x}>
        <Chip label={`#${x}`} onDelete={() => onDelete(x)} />
      </div>
    );
  });

  const content = !!currentCount ? chips : "No output";
  const outputHeading = !!currentCount ? (
    <h3>{`Output (${currentCount}/30)`}</h3>
  ) : (
    <h3>Output</h3>
  );

  const textToCopy = hashtags.map(x => `#${x}`).join(" ");
  const onCopyMessage = `The following output has been copied to your clipboard:\n${textToCopy}`;
  const onCopy = () => alert(onCopyMessage);

  return (
    <MuiThemeProvider>
      <div className="output">
        <div className="output-headingContainer">{outputHeading}</div>
        <div className="output-values">{content}</div>
        <div className="copyButtonContainer">
          <CopyToClipboard text={textToCopy} onCopy={onCopy}>
            <Button
              className="copyButton"
              type="button"
              icon="copy"
              disabled={isDisabled}
            >
              Copy
            </Button>
          </CopyToClipboard>
        </div>
      </div>
    </MuiThemeProvider>
  );
};

export default withStyles(styles)(Output);



// WEBPACK FOOTER //
// ./src/Output.js